import { render, staticRenderFns } from "./fktkdform.vue?vue&type=template&id=f597bfd0&scoped=true&"
import script from "./fktkdform.vue?vue&type=script&lang=js&"
export * from "./fktkdform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f597bfd0",
  null
  
)

export default component.exports